import { Wrapper, Icon } from "nystem-components";
import app from "nystem";
import { useEffect, useState } from "react";

const MapWeather = ({ model, view }) => {
  const [value, setValue] = useState();
  const [error, setError] = useState();
  useEffect(() => {
    let weatherData;
    let compass = 0;
    const update = () => {
      let current = model.show === "weather.0.description"
        ? weatherData?.weather?.map(item => item.description).join(", ")
        : model.show?.split(".").reduce((data, key) => data?.[key], weatherData);
      if (model.relative && model.show === "wind.deg" && Number.isFinite(current)) current = (current - compass + 360) % 360;
      setValue(current);
    };
    const weatherUpdate = query => {
      if (!Object.hasOwn(query, "weatherData")) return;
      weatherData = query.weatherData;
      setError(query.weatherError);
      update();
    };
    const position = data => { if (Number.isFinite(data.compass)) { compass = data.compass; update(); } };
    view.on("weatherUpdate", weatherUpdate);
    if (model.relative) { app.on("mapsDevicePos", position); app.event("mapsDevicePos"); }
    view.event("weatherUpdate").catch(() => {});
    return () => {
      if (model.relative) app.off("mapsDevicePos", position);
      view.off("weatherUpdate", weatherUpdate);
    };
  }, [model, view]);
  if (model.show === "wind.deg" && Number.isFinite(value))
    return <Icon icon="down-long" className={model.className} deg={value} />;
  const text = typeof value === "number" && model.decimal != null ? value.toFixed(model.decimal) : value;
  return <Wrapper className={model.className} title={error}>{text ?? model.fallback ?? "—"}</Wrapper>;
};

export default MapWeather;
